export default __webpack_public_path__ + "locales/pt/Settings.json?hash=4038353cf31be6f11f95d95d6485e0ef";